/*jshint esversion: 9 */
// import { mapGetters, mapActions } from 'vuex';
import InfoBox from '@/components/ProjectTaktPlan/InfoBox.component.vue';
export const InfoBoxMixin = {
  components: {
    InfoBox,
  },
  data: () => ({

  }),
  computed: {
    // ...mapGetters('View', [
    //   'is_show_side_bar'
    // ]),
  },
  methods: {

    // ...mapActions('View', [
    //   'setShowSideBar'
    // ]),
  }
};
